import { render, staticRenderFns } from "./PurposeEditModal.vue?vue&type=template&id=66682301&"
import script from "./PurposeEditModal.vue?vue&type=script&lang=js&"
export * from "./PurposeEditModal.vue?vue&type=script&lang=js&"
import style0 from "./PurposeEditModal.vue?vue&type=style&index=0&id=66682301&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports